import { Component } from 'react'
import SimpleSelect from 'components/shared/SimpleSelect'
import Input from 'shared-web/src/components/Input'
import _keyBy from 'lodash/keyBy'

const OperatorOptions = [
  { value: "lessThan", text: "is less than" },
  { value: "greaterThan", text: "is greater than" }
]

const OperatorByValue = _keyBy(OperatorOptions, 'value')

class ScrollPercentageInput extends Component {
  handleOperatorSelect = (operator) => {
    this.props.conditionUpdater('operator', operator)
  }

  handleChange = (value) => {
    this.props.conditionUpdater('value', parseInt(value))
  }

  isValid = () => {
    const value = this.props.conditionValue.get('value')
    return value >= 0 && value <= 100
  }

  renderOperatorSelection() {
    const operator = this.props.conditionValue.get('operator')
    const selectedValue = OperatorByValue[operator]
    const { text, value } = selectedValue
    return (
      <SimpleSelect
        onSelection={this.handleOperatorSelect}
        options={OperatorOptions}
        selectedValue={text || value}
      />
    )
  }

  renderNumericInput() {
    return (
      <Input
        type="number"
        min={0}
        max={100}
        step={1}
        valueLink={{
          requestChange: this.handleChange,
          value: this.props.conditionValue.get('value')
        }}
        isValid={this.isValid()}
      />
    )
  }

  render() {
    return (
      <div className="flex-space-around flex-1">
        { this.renderOperatorSelection() }
        { this.renderNumericInput() }
        { /* so layout doesn't freak out not proud of this */}
        <div style={{ width: 16 }}></div>
      </div>
    )
  }
}

export default ScrollPercentageInput



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/ScrollPercentageInput.js